let loaderPromise

export function loadAmap() {
  const key = process.env.VUE_APP_AMAP_KEY
  const securityCode = process.env.VUE_APP_AMAP_SECURITY_CODE

  if (!key) {
    return Promise.reject(new Error('请配置高德地图 Web 端 Key'))
  }

  if (window.AMapLoader) {
    return createMapLoader(key, securityCode)
  }

  if (!loaderPromise) {
    loaderPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = 'https://webapi.amap.com/loader.js'
      script.async = true
      script.onload = resolve
      script.onerror = () => reject(new Error('高德地图加载失败'))
      document.head.appendChild(script)
    })
  }

  return loaderPromise.then(() => createMapLoader(key, securityCode))
}

function createMapLoader(key, securityCode) {
  if (securityCode) {
    window._AMapSecurityConfig = {
      securityJsCode: securityCode
    }
  }

  return window.AMapLoader.load({
    key,
    version: '2.0',
    plugins: ['AMap.Scale', 'AMap.ToolBar', 'AMap.Geocoder']
  })
}
